module.exports = __webpack_public_path__ + "272e1a7b521bb7a072dc249a7ac3b081.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/save-emails-help-step-2.png
// module id = 166
// module chunks = 0 1